<template lang="pug">
  .two-factor__main(v-loading="isLoading" )
    .two-factor__container(v-if="dataLoaded")
      .two-factor-disable__container(v-if="is2faEnabled")
        .color-success 2FA установлен
        .two-factor-control__container
          el-input(v-model="token" placeholder="Введите код 2FA" )
          el-button(type="danger" @click="requestDisable2fa()") Отключить
      .two-factor-enable__container(v-else)
        .color-warning 2FA не установлен
        .two-factor-key {{ `Ключ: ${secret}` }}
        .two-factor-qr
          img(:src="qr" name="QR")
        .two-factor-control__container
          el-input(v-model="token" placeholder="Введите код 2FA" )
          el-button(type="success" @click="requestEnable2fa()") Подключить
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { DISABLE_2FA, ENABLE_2FA, GET_2FA_DATA } from "@/store/const/user";
import instruments from "@/mixins/instruments";

export default {
  name: 'TwoFactor',
  mixins: [
    instruments,
  ],
  data() {
    return {
      dataLoaded: false,
      is2faEnabled: false,
      secret: '',
      qr: '',
      token: '',
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    isLoading() {
      return this.loading(GET_2FA_DATA) === 'loading' || this.loading(ENABLE_2FA) === 'loading' || this.loading(DISABLE_2FA) === 'loading';
    },
  },
  mounted() {
    this.request2faData();
  },
  methods: {
    ...mapActions('user', {
      get2faData: GET_2FA_DATA,
      enable2fa: ENABLE_2FA,
      disable2fa: DISABLE_2FA,
    }),
    async request2faData() {
      const request = await this.get2faData();
      if (request.success) {
        if (request.data.enabled) {
          this.is2faEnabled = request.data.enabled;
        } else {
          this.secret = request.data.secret;
          this.qr = request.data.qrCode;
        }
        this.dataLoaded = true;
      } else {
        this.$message.error(`Ошибка получения данных 2FA: ${ request.message || 'Неизвестная ошибка' }`);
      }
    },
    async requestEnable2fa() {
      const request = await this.enable2fa({ secret: this.secret, token: this.token });
      await this.notifyRequestResult({
        request,
        successMessage: '2FA успешно подключен',
        errorMessage: 'Ошибка подключения 2FA',
        methodOnSuccess: () => { this.is2faEnabled = true; this.token = ''; },
      });
    },
    async requestDisable2fa() {
      const request = await this.disable2fa({ token: this.token });
      await this.notifyRequestResult({
        request,
        successMessage: '2FA успешно отключен',
        errorMessage: 'Ошибка отключения 2FA',
        methodOnSuccess: async () => { this.token = ''; this.is2faEnabled = false; await this.request2faData(); },
      });
    },
  }
};
</script>
<style scoped>
.two-factor-control__container {
    margin-top: 5px;
    display: flex;
}
</style>
